import { Splide } from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", () => {
  const sliderElementJob = document.querySelector(".job-slider");

  if (sliderElementJob) {
    const slideCount = sliderElementJob.querySelectorAll(".splide__slide").length;

    let defaultPerPage = 3;

    // Dynamisch anpassen bei wenigen Slides
    if (slideCount < defaultPerPage) {
      defaultPerPage = slideCount;
    }

    // 👉 Klasse setzen, wenn kein Slider nötig ist
    if (slideCount <= defaultPerPage) {
      sliderElementJob.classList.add("no-slider-needed");
    }

    new Splide(".job-slider", {
      type: "slide",
      perPage: defaultPerPage,
      perMove: 1,
      gap: "20px",
      arrows: true,
      pagination: false,
      breakpoints: {
        930: {
          perPage: Math.min(2, slideCount),
          focus: "center",
        },
        1400: {
          perPage: Math.min(2, slideCount),
        },
      },
    }).mount();
  }
});
